


































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import MarketsTemplateMenu from '@/components/templates/MarketsTemplate/MarketsTemplateMenu/index.vue';
import UnlockAllFeaturesDialog from '@/components/organisms/UnlockAllFeaturesDialog/index.vue';
import MarketFooter from '@/components/templates/MarketsTemplate/MarketFooter/index.vue';

@Component({
  name: 'MarketsTemplate',
  components: {
    MarketsTemplateMenu,
    SvgIcon,
    UnlockAllFeaturesDialog,
    MarketFooter,
  },
})
export default class MarketsTemplate extends Vue {
  @Prop() backgroundColor!: string;

  @Prop() backgroundCornerColor!: string;

  @Prop({ default: false }) outOfMarket!: boolean;
}
